var sizeMap = new Map([["xl", 80], ["l", 48], ["m", 36], ["s", 24], ["xs", 18]]);
var onlineStatusSizeMap = new Map([["xl", 18], ["l", 12], ["m", 8], ["s", 6], ["xs", 4]]);
var onlineStatusPositionMap = new Map([["xl", {
  bottom: 3,
  right: 3
}], ["l", {
  bottom: 2,
  right: 2
}], ["m", {
  bottom: 2,
  right: 2
}], ["s", {
  bottom: 1,
  right: 1
}], ["xs", {
  bottom: 1,
  right: 1
}]]);

export { onlineStatusPositionMap, onlineStatusSizeMap, sizeMap };
